import React from 'react';

import { CircularProgress } from '@mui/material';

import CustomModal from 'components/CustomModal';
import { Button } from 'components/Button';

interface ConvertToDynamicModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  leavingCount: number;
  saving: boolean;
}

const leavingSentence = (count: number): string =>
  count === 1
    ? '1 member doesn’t match the rule, so they’ll be removed.'
    : `${count} members don’t match the rule, so they’ll be removed.`;

const ConvertToDynamicModal: React.FunctionComponent<ConvertToDynamicModalProps> = ({
  open,
  onClose,
  onConfirm,
  leavingCount,
  saving,
}) => (
  <CustomModal
    openModal={open}
    onClose={onClose}
    modalTitle="Change to dynamic membership?"
    modalDescription={`Membership will update automatically as users’ details change. ${leavingSentence(leavingCount)}`}
    buttonsSpacing="space-between"
    cancelButton={
      <Button variant="outlined" size="large" onClick={onClose}>
        Cancel
      </Button>
    }
    submitButton={
      <Button variant="contained" size="large" onClick={onConfirm} disabled={saving}>
        {saving ? <CircularProgress size={18} /> : 'Change to dynamic'}
      </Button>
    }
  />
);

export default ConvertToDynamicModal;
